import React from 'react';
import FormattedLink from '../Parts/FormattedLink';
import { hasClass, addClass, removeClass } from '../../utils/dom';
import s from './SideMenu.scss';

const SideMenu = ({ navigation, staticTexts }) => {
	if (navigation.shopMenu === undefined) return null;
	const sideMenu = navigation !== undefined ? navigation.sideMenu : false;
	const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';

	const openMobileMenuHandler = (e) => {
		e.preventDefault();
		const $html = document.querySelector('html');
		if (hasClass($html, 'is-menuOpen')) {
			removeClass($html, 'is-menuOpen');
			removeClass($html, 'is-subMenuOpen');
		} else {
			addClass($html, 'is-menuOpen');
		}
	};

	const closeSideMenuHandler = () => {
		const $html = document.querySelector('html');
		removeClass($html, 'is-menuOpen');
		removeClass($html, 'is-subMenuOpen');
	};

	return (
		<div className={s.navigation}>
			<a href="#openMobileMenu" onClick={openMobileMenuHandler} className={s.sideMenu_mobileMenu} data-back={staticTexts.back}>{staticTexts.menu}</a>
			<div className={s.navigation_inner}>
				<nav className={[s.sideMenu, s.sideMenu__productMenu].join(' ')}>
					<ul className={s.sideMenu_list}>
						{
							navigation.shopMenu.map((item) => {
								const itemClasses = [s.sideMenu_list_item];
								if (currentPath.indexOf(`/shop/${item.URI}`) !== -1) itemClasses.push(s.sideMenu_list_item__selected);
								return (
									<li key={item.name} className={itemClasses.join(' ')}>
										<FormattedLink item={{ URI: `shop/${item.URI}`, name: item.name.replace('&amp;', '&') }} internal eventHandler={closeSideMenuHandler} />
									</li>
								);
							})
						}
					</ul>
				</nav><nav className={[s.sideMenu, s.sideMenu__navigationMenu].join(' ')}>
					{
						sideMenu ? (
							<ul className={s.sideMenu_list}>
								{
									sideMenu.map((item) => {
										const itemClasses = [s.sideMenu_list_item];
										if (currentPath.indexOf(`/${item.URI}`) !== -1) itemClasses.push(s.sideMenu_list_item__selected);
										return (
											<li key={item.name} className={itemClasses.join(' ')}>
												<FormattedLink item={item} internal eventHandler={closeSideMenuHandler} />
											</li>
										);
									})
								}
							</ul>
						) : null
					}
				</nav>
			</div>
		</div>
	);
};

export default SideMenu;



// WEBPACK FOOTER //
// ./components/SideMenu/SideMenu.jsx